import { RootState } from "reducks/rootReducer";

export const selectAccessToken = (state: RootState) => {
  return state.auth.accessToken;
};
export const selectAuthenticatedWith = (state: RootState) =>
  state.auth.authenticatedWith;
